import React from 'react';
import '../../css/aboutStylings/ContactEntryStyling.css';

// Helper function to sanitize user inputs
const sanitizeInput = (input) => {
    if (typeof input !== 'string') return '';

    return input
        .trim() // Remove leading/trailing whitespace
        .replace(/[<>]/g, '') // Remove potential HTML tags
        .replace(/javascript:/gi, '') // Remove javascript: protocols
        .replace(/on\w+\s*=/gi, '') // Remove event handlers like onclick=
        .replace(/script/gi, '') // Remove script tags
        .slice(0, input.includes('@') ? 254 : 1000); // Limit length (254 for email, 1000 for message)
};

const sanitizeInputForTyping = (input) => {
    if (typeof input !== 'string') return '';

    return input
        .replace(/[<>]/g, '') // Remove potential HTML tags
        .replace(/javascript:/gi, '') // Remove javascript: protocols
        .replace(/on\w+\s*=/gi, '') // Remove event handlers like onclick=
        .replace(/script/gi, '') // Remove script tags
        .slice(0, input.includes('@') ? 254 : 1000); // Limit length
};

// Helper function to validate email format
const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

const ContactEntryComponent = ({ messageSent }) => {
    const [emailContactEntry, setEmailContactEntry] = React.useState("");
    const [contactMessageEntry, setContactMessageEntry] = React.useState("");
    const [statusMessage, setStatusMessage] = React.useState("");
    const [statusType, setStatusType] = React.useState(""); // "success" or "error"

    const handleEmailChange = React.useCallback((e) => {
        const sanitized = sanitizeInput(e.target.value);
        setEmailContactEntry(sanitized);
    }, []);

    const handleMessageChange = React.useCallback((e) => {
        // const sanitized = sanitizeInputForTyping(e.target.value);
        setContactMessageEntry(e.target.value);
    }, []);

    // Optional: Add validation feedback
    const emailError = emailContactEntry && !isValidEmail(emailContactEntry);



    const handleSubmitMessage = React.useCallback(async () => {
        // Clear any existing status messages
        setStatusMessage("");
        setStatusType("");

        const messageData = {
            email: emailContactEntry,
            message: contactMessageEntry
        };

        console.log('Submitting contact entry:', messageData);

        try {
            const response = await fetch('/api/contact/sendContactMessage', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Sends cookies automatically
                body: JSON.stringify(messageData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to create message');
            }

            const result = await response.json();

            // Reset form
            setEmailContactEntry("");
            setContactMessageEntry("");

            // refresh contact messages after succeessfully adding one
            messageSent();

            // Set success message
            setStatusMessage("Message sent successfully!");
            setStatusType("success");

            // Clear the message after 5 seconds
            setTimeout(() => {
                setStatusMessage("");
                setStatusType("");
            }, 5000);

        } catch (error) {
            console.error('Error sending message:', error);

            // Set error message
            setStatusMessage(error.message || "Failed to send message. Please try again.");
            setStatusType("error");

            // Clear the message after 5 seconds
            setTimeout(() => {
                setStatusMessage("");
                setStatusType("");
            }, 5000);
        }
    }, [emailContactEntry, contactMessageEntry]);

    return (
        <div className={`contact-entry-component`}>
            <div className={`add-contact-field add-contact-value-field email-field`}>
                <label className="add-new-contact-field-title">
                    Email *
                </label>
                <input
                    type="email"
                    value={emailContactEntry}
                    onChange={handleEmailChange}
                    title={"Enter your email here"}
                    placeholder="Enter your email..."
                    className={`contact-entry-email-input ${emailError ? 'error' : ''}`}
                    required
                />
                {emailError && (
                    <span className="error-text">Please enter a valid email address</span>
                )}
            </div>

            <div className={`add-contact-field add-contact-value-field message-field`}>
                <label className="add-new-contact-field-title">
                    Message *
                </label>
                <textarea
                    value={contactMessageEntry}
                    onChange={handleMessageChange}
                    title={"Enter your message here"}
                    placeholder="Enter your message..."
                    className="contact-entry-message-input"
                    rows={4}
                    required
                />
            </div>

            <button
                onClick={handleSubmitMessage}
                className="add-contact-submit-button"
                disabled={!emailContactEntry || !contactMessageEntry }
            >
                Send Message
            </button>
        </div>
    )
}

export default ContactEntryComponent;